<template>
  <div class="chart">
    <apexchart
      :options="chartOptions"
      :series="chartSeries"
      type="line"
      height="400"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "TheLineChart",
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    data: Array, // Array contendo os valores para as 4 categorias
  },
  data() {
    const meses = [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez",
    ];

    // Calcula o maior valor no dataset +10 para dar folga no eixo Y
    const maxValue = Math.max(...this.data.flat()) + 5;

    return {
      chartOptions: {
        chart: {
          type: "line",
          height: 400,
          toolbar: { show: false },
          zoom: { enabled: false },
        },
        stroke: {
          curve: "smooth", // Linha com curvas suaves
          width: 3,
        },
        markers: {
          size: 6, // Tamanho dos pontos
          hover: { sizeOffset: 3 },
        },
        legend: {
          show: true,
          position: "top",
          horizontalAlign: "right",
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: { formatter: (val) => `${val} registros` },
        },
        xaxis: {
          categories: meses,
          labels: { style: { fontSize: "12px" } },
        },
        yaxis: {
          min: 0,
          max: maxValue,
          labels: { style: { fontSize: "12px" } },
        },
        colors: ["#4CAF50", "#2196F3", "#FFC107", "#F44336"],
      },
      chartSeries: [
        { name: "Resolvidos", data: this.data[0], color: "#009285" },
        { name: "Controlados", data: this.data[1], color: "#B49B5A" },
        { name: "Cancelados", data: this.data[2], color: "#898989" },
        { name: "Não controlado", data: this.data[3], color: "#920000" },
      ],
    };
  },
  watch: {
    data(newData) {
      this.chartSeries = [
        { name: "Resolvidos", data: newData[0], color: "#009285" },
        { name: "Controlados", data: newData[1], color: "#B49B5A" },
        { name: "Cancelados", data: newData[2], color: "#898989" },
        { name: "Não controlado", data: newData[3], color: "#920000" },
      ];
    },
  },
};
</script>

<style scoped>
.chart {
  margin: 3rem auto;
  width: 100%;
}
</style>
